/* eslint-disable max-len,import/prefer-default-export */
import {
    GridFilterOperator,
} from '@mui/x-data-grid-pro'

import {
    FilterType,
} from 'app/enums/common.enums'

import {
    SkyDataGridColumnDefinition,
    FilterOperatorType,
    SkyNetDataGridFilterType,
    SkyBaseDataSourceProvider,
} from '../SkyBaseDataGrid.types'

import {
    DateRangeFilterInputProps,
    DateRangeFilterInput,
    ArrayFilterAutocompleteInput,
    BooleanFilterInput,
    BooleanSwitchFilterInput,
    ArrayFilterAutocompleteInputProps,
} from '../components'

const FilterInputMap = {
    [FilterType.Array]: ArrayFilterAutocompleteInput,
    [SkyNetDataGridFilterType.Boolean]: BooleanFilterInput,
    [SkyNetDataGridFilterType.Toggle]: BooleanSwitchFilterInput,
    [SkyNetDataGridFilterType.DateRange]: DateRangeFilterInput,
}

type FilterInputsProps = DateRangeFilterInputProps & ArrayFilterAutocompleteInputProps

export const customEqualsOperator = (dataSource: SkyBaseDataSourceProvider,
    column: SkyDataGridColumnDefinition<any>): GridFilterOperator<any, any, any, FilterInputsProps>[] => {
    return !column.filterType ? [] : [{
        label: 'Equals',
        value: column.hiddenFromColumns ? FilterOperatorType.DataFilter : FilterOperatorType.EqualsIncludeFilter,
        getApplyFilterFn: () => {
            return (value) => {
                return (
                    value !== null
                )
            }
        },
        InputComponent: FilterInputMap[column.filterType],
        InputComponentProps: {
            requestBaseUrl: dataSource?.request?.url,
            requestData: dataSource?.request?.data,
            dataSourceKey: dataSource?.key,
            mask: column.filterDateMask,
        },
    }]
}
